const FORM = document.forms.inquiryForm;
const ACCOUNT = window.__GGAccountData;

function prefillField(element, value) {
    if (value && element && !element.value) {
        element.value = value;
        element.classList.add('-hasvalue');
    }
}

if (FORM && ACCOUNT && ACCOUNT.data) {
    const FIRST_NAME = document.getElementById('inquiryForm-firstName');
    const LAST_NAME = document.getElementById('inquiryForm-lastName');
    const EMAIL = document.getElementById('inquiryForm-email');
    prefillField(FIRST_NAME, ACCOUNT.data.firstName);
    prefillField(LAST_NAME, ACCOUNT.data.lastName);
    prefillField(EMAIL, ACCOUNT.data.email);
}
